import type { StorageProvider } from './StorageProvider';
import { STORAGE_KEYS } from './StorageProvider';

export class RomCache {
  constructor(private storage: StorageProvider) {}

  async getOrFetch(
    modelId: string,
    fetcher: () => Promise<Uint8Array>,
  ): Promise<Uint8Array> {
    const key = STORAGE_KEYS.romCache(modelId);
    const cached = await this.storage.get(key);
    if (cached) {
      return cached;
    }
    const data = await fetcher();
    await this.storage.set(key, data);
    return data;
  }

  async invalidate(modelId: string): Promise<void> {
    const key = STORAGE_KEYS.romCache(modelId);
    await this.storage.delete(key);
  }
}
